<div class="wrapper flex flex-col gap-[20px]">
  @if (!dateSelected) {
    <div class="heading text-type-1 flex flex-row justify-between items-center">
      <span> Pick a date to copy to</span>
      <span>
        <mat-icon
          (click)="close()"
          [svgIcon]="'close'"
          class="close-icon !mb[10px]"
          />
      </span>
    </div>
    <div class="calender-section min-w-full">
      <mat-calendar
        (selectedChange)="onDateSelected($event)"
        [(selected)]="selectedDate"
        class="!min-w-full !shadow-none"
        />
    </div>
    @if (existingReportId) {
      <div
        class="report-exists flex"
        >
        <mat-icon class="error-icon" svgIcon="error" />
        <div class="error-message text-type-14">
          A report is created by you for this date. Select a different date
        </div>
      </div>
    }
  }
  @if (dateSelected && !existingReportId) {
    <div class="heading text-type-1 flex flex-row justify-between items-center">
      <span>Select data</span>
      <span>
        <mat-icon
          (click)="close()"
          [svgIcon]="'close'"
          class="close-icon !mb[10px]"
          />
      </span>
    </div>
    <div class="selection-section min-w-full">
      <div class="widget-wrapper mb-[20px]">
        <app-checkbox-with-list
          (selectionChange)="onStatusCheckboxChange($event)"
          [displaySelectAll]="false"
          [options]="widgetOptions"
          [parentFormGroup]="form"
          class="each-widget"
          controlName="widgets"
          />
      </div>
    </div>
  }

  <div class="actions mt-[20px]">
    @if (!dateSelected) {
      <app-primary-button
        (handleClick)="copy()"
        [isDisabled]="!selectedDate"
        >
        Next
      </app-primary-button>
    }

    @if (dateSelected) {
      <app-primary-button
        (handleClick)="proceed()"
        [isDisabled]="!selectedDate"
        >
        Copy
      </app-primary-button>
    }
  </div>
</div>

